import { Button, Tooltip } from '@mui/material';
import React from 'react';

/**
 * This function represents a cancel button.
 * @returns React.Component
 */
export default function CancelButton({ disabled, title, onClick, children }) {
  return (
    <Tooltip title={title ? title : ''}>
      <span>
        <Button onClick={onClick} disabled={disabled} fullWidth={true} variant="outlined" className="cancel-button">
          {children ? children : 'Annuleren'}
        </Button>
      </span>
    </Tooltip>
  );
}
